"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FUNNEL_HANDOFF_DESTINATION_URL_PATHS = exports.texasHandoffSourcePageUrlPaths = exports.texasLandingPageUrlPaths = exports.depositFlowEntryUrlPaths = exports.firstLienPurchaseOriginationFlowEntryUrlPaths = exports.mortgageFlowEntryUrlPaths = exports.uccSpecialFlowEntryUrlPaths = exports.originationFlowEntryUrlPaths = exports.uccFlowEntryUrlPaths = exports.toUrlPaths = exports.toUrlPath = exports.depositFlowEntryPaths = exports.firstLienPurchaseOriginationFlowEntryPaths = exports.mortgageFlowEntryPaths = exports.uccSpecialFlowEntryPaths = exports.originationFlowEntryPaths = exports.uccFlowEntryPaths = exports.isEntryPathForFlow = exports.getEntryPathsForFlow = void 0;
const flows_1 = require("../flows");
const landingPageRegistry_1 = require("./landingPageRegistry");
/**
 * Derives an array of landing page paths that can serve as entry points for a given flow.
 *
 * @param flow - The flow to filter by
 * @returns Array of LandingPagePath values that have the specified flow in their entryFlows
 */
const getEntryPathsForFlow = (flow) => {
    return Object.entries(landingPageRegistry_1.LANDING_PAGE_PRODUCT_CONFIG)
        .filter(([_, config]) => config.entryFlows?.includes(flow))
        .map(([path]) => path);
};
exports.getEntryPathsForFlow = getEntryPathsForFlow;
/**
 * Checks if a given path can serve as an entry point for a specific flow.
 *
 * @param path - The landing page path to check
 * @param flow - The flow to check against
 * @returns true if the path can be an entry point for the flow, false otherwise
 */
const isEntryPathForFlow = (path, flow) => {
    const config = landingPageRegistry_1.LANDING_PAGE_PRODUCT_CONFIG[path];
    return config?.entryFlows?.includes(flow) ?? false;
};
exports.isEntryPathForFlow = isEntryPathForFlow;
/**
 * Pre-computed arrays of entry paths for each flow type.
 * These are derived from LANDING_PAGE_PRODUCT_CONFIG at module load time.
 *
 * Usage in flow files:
 * - Import these instead of manually maintaining string arrays
 * - Paths are type-safe (LandingPagePath enum values)
 * - Single source of truth in LANDING_PAGE_PRODUCT_CONFIG
 */
/** Entry paths for the UCC (Unsecured Credit Card) flow */
exports.uccFlowEntryPaths = (0, exports.getEntryPathsForFlow)(flows_1.Flows.uccOrigination);
/** Entry paths for the standard HOME origination flow */
exports.originationFlowEntryPaths = (0, exports.getEntryPathsForFlow)(flows_1.Flows.origination);
/** Entry paths for the special UCC flow (bundle product) */
exports.uccSpecialFlowEntryPaths = (0, exports.getEntryPathsForFlow)(flows_1.Flows.uccSpecialOrigination);
/** Entry paths for the mortgage flow */
exports.mortgageFlowEntryPaths = (0, exports.getEntryPathsForFlow)(flows_1.Flows.mortgageOrigination);
/** Entry paths for the first-lien purchase origination flow */
exports.firstLienPurchaseOriginationFlowEntryPaths = (0, exports.getEntryPathsForFlow)(flows_1.Flows.firstLienPurchaseOrigination);
/** Entry paths for the deposit flow */
exports.depositFlowEntryPaths = (0, exports.getEntryPathsForFlow)(flows_1.Flows.depositOrigination);
/**
 * Converts a LandingPagePath to its URL path string (with leading slash).
 *
 * @param landingPagePath - The LandingPagePath enum value
 * @returns The URL path string (e.g., '/landing', '/rewards')
 */
const toUrlPath = (landingPagePath) => {
    return `/${landingPagePath}`;
};
exports.toUrlPath = toUrlPath;
/**
 * Converts an array of LandingPagePath values to URL path strings.
 *
 * @param paths - Array of LandingPagePath enum values
 * @returns Array of URL path strings
 */
const toUrlPaths = (paths) => {
    return paths.map(exports.toUrlPath);
};
exports.toUrlPaths = toUrlPaths;
/**
 * Pre-computed URL path strings for each flow type.
 * These are the string versions of the entry paths, suitable for route matching.
 */
/** URL paths for UCC flow entry points */
exports.uccFlowEntryUrlPaths = (0, exports.toUrlPaths)(exports.uccFlowEntryPaths);
/** URL paths for origination flow entry points */
exports.originationFlowEntryUrlPaths = (0, exports.toUrlPaths)(exports.originationFlowEntryPaths);
/** URL paths for UCC special flow entry points */
exports.uccSpecialFlowEntryUrlPaths = (0, exports.toUrlPaths)(exports.uccSpecialFlowEntryPaths);
/** URL paths for mortgage flow entry points */
exports.mortgageFlowEntryUrlPaths = (0, exports.toUrlPaths)(exports.mortgageFlowEntryPaths);
/** URL paths for first-lien purchase origination flow entry points */
exports.firstLienPurchaseOriginationFlowEntryUrlPaths = (0, exports.toUrlPaths)(exports.firstLienPurchaseOriginationFlowEntryPaths);
/** URL paths for deposit flow entry points */
exports.depositFlowEntryUrlPaths = (0, exports.toUrlPaths)(exports.depositFlowEntryPaths);
/** URL paths of the Texas landing pages */
exports.texasLandingPageUrlPaths = (0, exports.toUrlPaths)([...landingPageRegistry_1.TEXAS_LANDING_PAGE_PATHS]);
/** Public URL paths for Texas-homestead handoff sources. */
exports.texasHandoffSourcePageUrlPaths = landingPageRegistry_1.TEXAS_HANDOFF_SOURCE_PAGE_PATHS.map((path) => (path === landingPageRegistry_1.LandingPagePath.LANDING ? '/' : (0, exports.toUrlPath)(path)));
/** The two funnels a property handoff routes between: the Texas landing page, and the main funnel. */
exports.FUNNEL_HANDOFF_DESTINATION_URL_PATHS = {
    texasLandingPage: (0, exports.toUrlPath)(landingPageRegistry_1.LandingPagePath.TEXAS_D2C_LANDING),
    mainFunnel: '/',
};
